import React from "react";

// reactstrap components
import { Container, Row, Col, Button } from "reactstrap";

import OthelloCarrusel from "../../componentsothello/OthelloCarrusel.js";

import { TipoCarrusel } from "../../othelloConstantes.jsx";
import { GetInfoAdicionalHeaderCorporativa } from "../../othelloFunciones.jsx";

import { useTranslation } from 'react-i18next';


function IndexHeader({ ...props }) {

    const { } = props;    

    const { t } = useTranslation();

    const [items, setItems] = React.useState(null);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        fetch('api/Data/GetImagenesPortadaOficina')
            .then(response => response.json())
            .then(data => {
                setItems(data);
                setLoading(false)
            }).catch(error => {
                setItems(null);
                setLoading(false)
            });
    }, [loading]);

 
  return (
    <>
          <div className="header-3">              
              <div className="page-carousel">
                  <div className="filter" />                  
                  {!loading && items != null && items.length > 0 ? <OthelloCarrusel tipo={TipoCarrusel.Portada} carouselItems={items} />  : ""}
              </div>
          </div>
          {
              //Si estamos trabajando con los apartamentos
              !loading && items != null && items.length > 0 ? GetInfoAdicionalHeaderCorporativa(items[0], t) : ""                                            
          }
    </>
  );
}

export default IndexHeader;

    //&& items[0].idofi == 104 ?
    //<div className="header-3" style={{ backgroundColor: '#eeeeee', height: 100 }}>
    //    <Container>
    //        <Row>
    //            <Col className="ml-auto mr-auto" md="6">
    //                <h4 className="description" style={{ marginTop: 35 }}>
    //                    <b>Reserve de una manera rapida y sencilla</b>
    //                </h4>
    //            </Col>
    //            <Col className="ml-auto mr-auto" md="3" style={{ marginTop: 25 }}>
    //                <Button
    //                    color="info"
    //                    href="https://www.booking.com/hotel/es/apartamentos-auhabitatzaragoza.es.html"
    //                    size="lg"
    //                    target="_blank">
    //                    <i class="fa fa-suitcase" aria-hidden="true"></i> {"Reservar"}
    //                </Button>
    //            </Col>
    //            <Col className="ml-auto mr-auto" md="3">
    //                <h4><b>+34 976437907</b></h4>
    //                <center><span className='text-info'><b> <b>contacto@authabitatzaragoza.com</b></b></span></center>
    //            </Col>
    //        </Row>
    //    </Container>
    //</div> : ""